import { log } from "console";
import SimpleCard from "../../components/card/simpleCard/simpleCard";
import { INotificationCard } from "./INotificationCard";
import InfoIcon from '@mui/icons-material/Info';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import NotificationModal from "../../components/modal/notificationModal/notificationModal";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { changeNoticeStatusToObserved } from "../../services/notification.service";
import { IChangeNoticeStatusToObservedResponse } from "../../models/notification.model";

export default function NotificationCard({ title, date, seenDate, noticeType, id, description, setChangeNoticeStatus }: INotificationCard) {
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const handleChange = () => {
        setOpenVerifyModal(true);
    }
    useEffect(() => {
        if (confirm === true) {
            ChangeNoticeStatusToObservedMutate({ appNoticeId: id });
            setConfirm(false);
        }
    }, [confirm === true])

    const { mutate: ChangeNoticeStatusToObservedMutate } = useMutation(
        changeNoticeStatusToObserved,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    setChangeNoticeStatus(true);
                }
            },
        }
    );
    return (
        <SimpleCard>
            <div onClick={handleChange}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                    <div style={{ alignContent: "flex-start" }}>
                        <span style={{ fontSize: "0.75rem", fontWeight: "bold", paddingRight: "5px" }} className="primaryColorLight-900">
                            {noticeType === 'Warning' ? <ReportProblemIcon style={{ color: `${seenDate === null ? '#FF617C' : '#D7DBEC'}`, marginLeft: '8px' }} /> :
                                noticeType === 'Information' ? <InfoIcon style={{ color: `${seenDate === null ? '#BBA57A' : '#D7DBEC'}`, marginLeft: '8px' }} /> : null}
                            {title}
                        </span>
                    </div>
                </div>
                <hr style={{ color: '#D7DBEC', paddingBottom: "10px", borderTop: "2px solid" }} />
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                    <div style={{ alignContent: "flex-start" }}>
                        <span style={{ fontSize: "0.62rem", fontWeight: "medium", paddingRight: "5px", color: '#31B0D5' }}>{seenDate! == null ? 'خوانده نشده' : 'خوانده شده'}</span>
                    </div>
                    <div style={{ alignContent: "flex-end" }}>
                        <span style={{ fontSize: "0.62rem" }} className="primaryColorLight-100"> {date}</span>
                    </div>
                </div>
            </div>
            <NotificationModal
                title={title}
                description={description}
                noticeType={noticeType}
                buttonTitle={'متوجه شدم'}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
                seenDate={seenDate}
            />
        </SimpleCard>

    );
}

